module.exports = __webpack_public_path__ + "static/media/bg.b2566064.jpg";